/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MeterCreate = {
    properties: {
        type: {
            type: 'UtilityTypeEnum',
            isRequired: true,
        },
        meterNumber: {
            type: 'string',
            isNullable: true,
        },
        location: {
            type: 'string',
            isNullable: true,
        },
        isActive: {
            type: 'boolean',
            isRequired: true,
        },
    },
};